const CHALLENGE_STATUS = {
  ONGOING: "ONGOING",
  COMPLETED: "COMPLETED",
};

export default CHALLENGE_STATUS;
